// extracted by mini-css-extract-plugin
export var attachment = "_q2-a";
export var emailContainer = "_q2-4";
export var emailContentPaddedContainer = "_q2-b";
export var emailHeader = "_q2-6";
export var emailIframe = "_q2-3";
export var emailInfoIcon = "_q2-9";
export var emailShortenedSummary = "_q2-e";
export var infoDropdown = "_q2-0";
export var infoRowBoundedContent = "_q2-d";
export var internal = "_q2-5";
export var merchant = "_q2-8";
export var messageInputContainer = "_q2-h";
export var normal = "_q2-7";
export var replyCard = "_q2-f";
export var subtleButton = "_q2-1";
export var subtleButtonIconContainer = "_q2-2";
export var toggleViewRepliesButton = "_q2-c";
export var wrappingText = "_q2-g";